module.exports = __webpack_public_path__ + "static/media/checkstyle03.bc409ac7.png";